import React, { useState, useEffect } from "react"
import { Link, useHistory, useLocation, useParams } from "react-router-dom"
import { Col, Card, CardImg, CardBody, CardTitle, CardText, Spinner } from "reactstrap"
import { ethers } from "ethers"
import { Provider, utils, Wallet, Web3Provider } from "zksync-web3"

import blankLoadingPic from "../../assets/images/blank-loading.png"
import idexoLogo from "../../assets/images/logo-dark.png"
import { useToast } from "../../hooks/toast"

import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"
import LoadingOrErrorCard from "../../Components/LoadingOrErrorCard/LoadingOrErrorCard"
import ConfirmSubmitModal from "../../Components/ConfirmSubmitModal/ConfirmSubmitModal"
import ConnectWallet from "../../Components/ConnectWallet"
import BreadCrumb from "../../Components/BreadCrumb"
import Tooltip from "../../Components/Tooltip"
import ZkNftCard from "../../Components/NftCard/ZkNftCard"

import zkNftAbi from "../../abi/ZkStandardNFTCollection.json"

import { networkIcons, flattenTokenGatingNFTs, formatTokenURI } from "../../utils"

const testContractAddress = ""
const realContractAddress = "0xd0767d49E0E30b8fB4484D86f0bD1f80aBc3e74C"

const ZkViewer = () => {
    const web3 = new Web3(window.ethereum)
    const wallet = useWallet()
    const toast = useToast()
    const history = useHistory()
    const location = useLocation()
    const params = useParams()
    // const [isConnectedToWallet, setIsConnectedToWallet] = useState(wallet?.status === "connected")
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [userNFTs, setUserNFTs] = useState([]) // [{ chain:'bnbchain', tokens:[] }, { chain:'polygon', tokens:[]}, {}, {}, ...]
    const [showLoadingNFTs, setShowLoadingNFTs] = useState(false) // spinner animation for fetching user community nfts
    const [errorMessage, setErrorMessage] = useState("") // error alert fetching user community nfts
    const [isLoading, setIsLoading] = useState(false)

    const [headerText, setHeaderText] = useState("View Your Minted NFTs")

    const [modalAlertMessage, setModalAlertMessage] = useState("")
    const [modalAlertColor, setModalAlertColor] = useState("")
    const [disableModalButtons, setDisableModalButtons] = useState(false)
    const [showConfirmLoading, setShowConfirmLoading] = useState(false) // loading animation after clicking "confirm" button
    const [activeCardId, setActiveCardId] = useState(null)

    const rpcUrl = "https://mainnet.era.zksync.io"
    // const chainId = 324

    const provider = new Provider(rpcUrl, chainId)
    const [chainId, setChainId] = useState(undefined)
    const [account, setAccount] = useState(0)

    // TO DO: move to utils.js for reuse/DRY
    const handleCopyClick = (e, link) => {
        e.stopPropagation()
        navigator.clipboard.writeText(link?.replace("×", "x"))
        toast.addSuccess(`Token URI ${formatTokenURI(link)} is copied to clipboard.`)
    }

    const handleCardClick = (id) => {
        // setActiveCardId(id)
        const nft = userNFTs[id]
        history.push(`/zkviewnft/${nft.tokenId}`, { nft, id })
    }

    const handleBack = () => {
        setActiveCardId(null)
    }

    const getNFTContract = (contractAddress) => {
        return new ethers.Contract(contractAddress, zkNftAbi, provider)
    }

    const getTokenUri = async (contractAddress, tokenId) => {
        const tokenUri = await getNFTContract(contractAddress).tokenURI(tokenId)
        return tokenUri
    }

    const getUserTokens = async (contractAddress, walletAddress) => {
        try {
            setIsLoading(true)
            const nftContract = getNFTContract(contractAddress)
            // console.log("nft contract: " + JSON.stringify(nftContract))
            const nftName = await getNFTContract(contractAddress).name()
            const isHolder = await nftContract.isHolder(walletAddress)
            if (!isHolder) {
                setIsLoading(false)
                return []
            }
            const tokenIds = await nftContract.getCollectionIds(walletAddress)

            const nfts = []

            for (const tokenId of tokenIds) {
                const tokenIdStr = tokenId.toString()
                console.log("token id: " + tokenIdStr)
                try {
                    const tokenURI = await nftContract.tokenURI(tokenId)
                    console.log("token URI: " + tokenURI)
                    const metadataResponse = await fetch(tokenURI)
                    const metadata = await metadataResponse.json()
                    console.log("metadata: " + JSON.stringify(metadata))
                    nfts.push({ tokenId: tokenIdStr, tokenURI, metadata, name: nftName })
                } catch (error) {
                    console.error("Error fetching metadata for tokenId " + tokenId + ": ", error)
                }
            }
            setIsLoading(false)
            return nfts
        } catch (error) {
            console.error("Error fetching NFTs:", error)
            return []
        }
    }

    const updateConnection = () => {
        const x = wallet.status === "connected"
        setIsConnectedToWallet(x)
        return x
    }

    useEffect(() => {
        ;(async () => {
            setIsConnectedToWallet(wallet.status === "connected")
            if (wallet.account) {
                try {
                    setAccount(wallet.account)
                    setChainId(wallet.chainId)
                    const fetchedUserNFTs = await getUserTokens(realContractAddress, wallet.account)
                    setUserNFTs(fetchedUserNFTs)
                    // console.log('user nfts: ' + JSON.stringify(fetchedUserNFTs))
                } catch (err) {
                    console.log(err)
                }
            }
        })()
    }, [wallet, wallet.account])

    useEffect(() => {
        // Extract the NFT ID or other identifying parameter from the URL
        const { id } = params // Assuming the route param is named `id`
        // const numericId = parseInt(id, 10); // Convert to a number

        // Find the index of the NFT based on the ID extracted from the URL
        const nftIndex = userNFTs.findIndex((nft) => nft.tokenId.toString() === id)
        // console.log("id: " + id + " nftIndex: " + nftIndex)

        if (nftIndex >= 0) {
            setActiveCardId(nftIndex)
        } else {
            setActiveCardId(null) // Reset or handle the case where the NFT is not found
        }
    }, [location, params, userNFTs]) // React to changes in location or NFT list

    // useEffect(async () => {
    //     if (updateConnection() && wallet.account) {
    //         const fetchedUserNFTs = await getUserTokens(realContractAddress, wallet.account)
    //         setUserNFTs(fetchedUserNFTs)
    //         console.log('user nfts: ' + JSON.stringify(fetchedUserNFTs))
    //     }
    // }, [wallet.account])

    return (
        <div className="content token-gating">
            {/* OLD BreadCrumb */}
            {/* <BreadCrumb current="Token Gating" /> */}
            <BreadCrumb items={["View NFTs"]} />

            {!isConnectedToWallet ? (
                <Card className="token-gating-welcome">
                    <CardBody>
                        <CardTitle className="h3">{headerText}</CardTitle>
                        <CardText>Connect your wallet and your zkSync to view your NFTs.</CardText>
                        <CardBody>
                            <ConnectWallet wallet={wallet} onChange={updateConnection} isTokenGating={true} />
                        </CardBody>
                    </CardBody>
                </Card>
            ) : (
                <React.Fragment>
                    <Card className="token-gating-welcome">
                        <CardBody>
                            <CardTitle className="h3">{headerText}</CardTitle>
                            {isLoading ? (
                                // text that shows when card is loading
                                <LoadingOrErrorCard loadingTxt="Checking for NFTs" className="token-gating-loading" />
                            ) : (
                                <React.Fragment>
                                    {errorMessage && (
                                        <LoadingOrErrorCard
                                            // text that shows if there's an error checking the user's nft's
                                            errorTxt={"Error checking for NFTs"}
                                            alertMessage={errorMessage}
                                            className="token-gating-loading"
                                        />
                                    )}

                                    {!userNFTs?.length && !errorMessage && (
                                        // text that shows if the user has no token gated NFTs
                                        <LoadingOrErrorCard emptyTxt="You have no Art NFTs" emptyTxt2={""} className="token-gating-loading" />
                                    )}

                                    {userNFTs?.length >= 1 &&
                                        !errorMessage &&
                                        (activeCardId !== null ? (
                                            <ZkNftCard nft={userNFTs[activeCardId]} cardId={userNFTs[activeCardId].tokenId} />
                                        ) : (
                                            <React.Fragment>
                                                <div className="welcome-message">
                                                    <div className="app">Welcome to the zkSync Art Contest</div>
                                                    <div className="app">Below are your NFTs</div>
                                                </div>
                                                <div className="token-gating-card-wrap">
                                                    {userNFTs?.map((token, idx) => (
                                                        <Col key={idx} sm="12" md="12" lg="12" xl="12">
                                                            <Card className="clickable-card" id={token.tokenId} onClick={() => handleCardClick(idx)}>
                                                                <CardImg top width="100%" src={token.metadata.image} alt="NFT Image" />
                                                                <CardBody>
                                                                    <CardTitle tag="h5">{token.metadata.name}</CardTitle>
                                                                    <div>Description: {token.metadata.description}</div>
                                                                    <div>
                                                                        Token URI: {formatTokenURI(token.tokenURI)}
                                                                        <Tooltip title="Copy TokenURI link to clipboard" placement="bottom">
                                                                            <i
                                                                                className="bx bx-copy font-size-20"
                                                                                onClick={(e) => handleCopyClick(e, token.tokenURI)}
                                                                            />
                                                                        </Tooltip>
                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                </div>
                                            </React.Fragment>
                                        ))}
                                </React.Fragment>
                            )}
                        </CardBody>
                    </Card>
                </React.Fragment>
            )}
        </div>
    )
}

export default ZkViewer
